// extracted by mini-css-extract-plugin
export default {"email":"email_email__jBWm4","emailInner":"email_emailInner__AD35J","heading":"email_heading__gr-+-"};